import { hasExceededTimes } from "@/utils/math";
import { defineStore } from "pinia";

interface UserState {
    /**
     * occ token
     */
    access_token: string,
    /**
     * occ 过期时间
     */
    expire: number,
    /**
     * 浏览器指纹
     */
    finger: string,
}

export const useUserStore = defineStore({
    id: 'app-user',
    persist: true,
    state: (): UserState => ({
        access_token: '',
        expire: 0,
        finger: '',
    }),
    actions: {
        setTokenInfo(token: string, expire: number) {
            this.access_token = token;
            this.expire = expire;
        },
        setFinger(finger: string) {
            this.finger = finger;
        }
    },
    getters: {
        checkOccAuth: state => state.access_token && hasExceededTimes(state.expire),
    }
})